module.exports = __webpack_public_path__ + "img/Latvia.3ae01645.svg";